<template>
    <div>
        <font-awesome-icon class="screenfull-svg" :icon="isFullscreen ? 'compress-alt' : 'expand-alt'" @click="click" />
    </div>
</template>

<script>
import screenfull from 'screenfull'

export default {
    name: `Screenfull`,
    data() {
        return {
            isFullscreen: false
        }
    },
    mounted() {
        this.init()
        window.onresize = () => {
            // 全屏下监控是否按键了ESC
            if (!this.checkFull()) {
                // 全屏下按键esc后要执行的动作
                this.isFullscreen = false
            }
        }

        this.$EventBus.$on(`fullScreenChange`, (isFullscreen) => {
            this.click()
        })
    },
    beforeDestroy() {
        this.destroy()
    },
    methods: {
        click() {
            if (!screenfull.enabled) {
                this.$message({
                    message: `you browser can not work`,
                    type: `warning`
                })
                return false
            }
            screenfull.toggle()
        },
        change() {
            this.isFullscreen = screenfull.isFullscreen
        },
        init() {
            if (screenfull.enabled) {
                screenfull.on(`change`, this.change)
            }
        },
        destroy() {
            if (screenfull.enabled) {
                screenfull.off(`change`, this.change)
            }
        }
    }
}
</script>

<style scoped>
.screenfull-svg {
    /*display: inline-block;*/
    cursor: pointer;
    /*fill: #5a5e66;*/
    /*width: 20px;
    height: 20px;*/
    /*vertical-align: 10px;*/
    /*line-height:50px;*/
    /*font-size:24px;*/
    /*height:50px*/
}
</style>



// WEBPACK FOOTER //
// src/common/Screenfull.vue